declare global {
  interface Window {
    __nativeFetch?: typeof fetch;
    __nativeXMLHttpRequest?: typeof XMLHttpRequest;
  }
}

// Prefer the earliest-captured fetch if index.html stored it, otherwise bind now.
const ensureNativeFetch = (): typeof fetch => {
  if (window.__nativeFetch && typeof window.__nativeFetch === "function") {
    return window.__nativeFetch;
  }

  const bound = window.fetch.bind(window);
  window.__nativeFetch = bound;
  return bound;
};

export const getNativeFetch = (): typeof fetch => ensureNativeFetch();

// Restore the original fetch on window to disable any instrumentation that wrapped it.
export const restoreNativeFetch = (): void => {
  const native = ensureNativeFetch();
  window.fetch = native;
};

// Prefer the earliest-captured XMLHttpRequest if index.html stored it.
const ensureNativeXhr = (): typeof XMLHttpRequest => {
  if (
    window.__nativeXMLHttpRequest &&
    typeof window.__nativeXMLHttpRequest === "function"
  ) {
    return window.__nativeXMLHttpRequest;
  }

  // Fallback to current constructor if no earlier capture exists.
  window.__nativeXMLHttpRequest = window.XMLHttpRequest;
  return window.XMLHttpRequest;
};

export const getNativeXhr = (): typeof XMLHttpRequest => ensureNativeXhr();

// Restore the original XMLHttpRequest constructor to disable instrumentation.
export const restoreNativeXhr = (): void => {
  const native = ensureNativeXhr();
  window.XMLHttpRequest = native;
};
